import { Route } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { NotAllowedComponent } from './not-allowed/not-allowed.component';
import { authedGuard } from './authed.guard';
import { MakeCallComponent } from './make-call/make-call.component';
import { SendMessageComponent } from './send-message/send-message.component';

export const appRoutes: Route[] = [
  {
    canActivate: [
      authedGuard
    ],
    component: HomepageComponent,
    path: '',
    pathMatch: 'full',
  },
  {
    canActivate: [
      authedGuard
    ],
    component: MakeCallComponent,
    path: 'make-call',
  },
  {
    component: NotAllowedComponent,
    path: 'not-allowed',
  },
  {
    canActivate: [
      authedGuard
    ],
    component: SendMessageComponent,
    path: 'send-message',
  },
  {
    component: SignInComponent,
    path: 'sign-in',
  },
  {
    component: SignOutComponent,
    path: 'sign-out',
  },
];
